$brand_app $mol_book2
	title \Бренд $mol
	plugins /
		<= Theme $mol_theme_auto
	pages /
		<= Color $brand_app_color
		<= Example $brand_app_example
